export default __webpack_public_path__ + "static/media/ic_play_video.c7781ceb.gif";